import React from 'react';

import language from '../../../assets/languages/language';

function ValidateButton({ onValidate, disabled = false }) {
  return (
    <button
      type='button'
      className='btn btn-primary pointer_class margin_right_10 mb-0'
      onClick={onValidate}
      style={{ height: '38px' }}
      disabled={disabled}
    >
      {language.LC().VALIDATE}
    </button>
  );
}

export default ValidateButton;



// WEBPACK FOOTER //
// ./src/views/ESG/QuestionBank/ValidateButton.jsx